import { inject, Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { UserDTO } from 'src/app/dto/responses/UserDTO';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private storage = inject(Storage);
  private sessionStore = new Map<string, string>();

  private isSessionAvailable(): boolean {
    try {
      return typeof window !== 'undefined' && !!window.sessionStorage;
    } catch {
      return false;
    }
  }

  /**
   * Storage normal de Ionic Storage
   */

  async init() {
    await this.storage.create();
  }

  public async get<T>(key: string) {
    return await this.storage.get(key);
  }

  public async set<T>(key: string, value: T) {
    await this.storage.set(key, value);
  }

  public remove(key: string) {
    this.storage.remove(key);
  }

  /**
   * Session Storage (in-memory si no está disponible)
   */

  public setSessionStorage(key: string, value: string): void {
    if (this.isSessionAvailable()) {
      window.sessionStorage.setItem(key, value);
    } else {
      this.sessionStore.set(key, value);
    }
  }

  public getSessionStorage(key: string): string | null {
    try {
      let raw: string | null = null;
      if (this.isSessionAvailable()) {
        raw = window.sessionStorage.getItem(key);
      } else {
        raw = this.sessionStore.get(key) ?? null;
      }
      return raw;
    } catch {
      return null;
    }
  }

  public removeSessionStorage(key: string): void {
    if (this.isSessionAvailable()) {
      window.sessionStorage.removeItem(key);
    } else {
      this.sessionStore.delete(key);
    }
  }

  public clearSessionStorage(): void {
    if (this.isSessionAvailable()) {
      window.sessionStorage.clear();
    } else {
      this.sessionStore.clear();
    }
  }
}
